/** SDTestApp FI-5A-W family prefix burned onto 14-digit device labels at SGS configure. */
export const SGS_FI5AW_DEVICE_LABEL_PREFIX = "1060723";

/** Seven-digit SDTestApp counter suffix (e.g. 5590041 → 10607235590041). */
const SGS_FI5AW_SUFFIX_ONLY = /^5590\d{3}$/;

/**
 * Legacy numeric device labels are longer (for example 14 digits). Short printed labels always include a
 * letter; SDTestApp `fciSerialNumber` tails are digits-only (for example 630353).
 *
 * Keep in sync with `src/api/manufacturing-configuration/device-label-serial.ts`.
 */
export const MIN_ALL_DIGIT_DEVICE_LABEL_LENGTH = 10;

export const BARE_SDTEST_DEVICE_LABEL_SUFFIX_MESSAGE =
  "Device label is digits-only and too short to be a printed sticker (for example 630353 from SDTestApp). " +
  "Scan the full printed label; short labels always include a letter (for example A106268630353).";

export function isBareSdTestDeviceLabelSuffix(raw: string | null | undefined): boolean {
  const trimmed = String(raw ?? "").trim();
  if (trimmed === "") return false;
  if (SGS_FI5AW_SUFFIX_ONLY.test(trimmed)) return false;
  if (!/^\d+$/.test(trimmed)) return false;
  return trimmed.length < MIN_ALL_DIGIT_DEVICE_LABEL_LENGTH;
}

/**
 * SDTestApp sometimes exposes only the seven-digit counter in `fciSerialNumber` while the physical label and
 * `deviceLabelSerial` carry the full 14-digit value. Never persist the bare suffix for wireless units.
 *
 * Keep in sync with `src/api/manufacturing-configuration/device-label-serial.ts`.
 */
export function normalizeSgsWirelessDeviceLabelSerial(raw: string | null | undefined): string {
  const trimmed = String(raw ?? "").trim();
  if (trimmed === "") return "";
  if (SGS_FI5AW_SUFFIX_ONLY.test(trimmed)) {
    return `${SGS_FI5AW_DEVICE_LABEL_PREFIX}${trimmed}`;
  }
  return trimmed;
}

export function resolveDeviceLabelSerialFromCandidates(
  candidates: readonly (string | null | undefined)[],
): string {
  const normalized = candidates
    .map((value) => normalizeSgsWirelessDeviceLabelSerial(value))
    .filter((value) => value !== "");
  if (normalized.length === 0) return "";

  const unique = [...new Set(normalized)];
  unique.sort((left, right) => right.length - left.length || left.localeCompare(right));
  return unique[0] ?? "";
}
